/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import classNames from 'classnames';
import Spinner from 'react-spinkit';
import PlacesAutocomplete from 'react-places-autocomplete';
import { loadGoogleMapsPlaces } from '../../lib/loadGoogleMapsPlaces';

export default class PlacesAutocompleteInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      address: '',
      mapsReady: false,
      mapsLoadFailed: false,
    };
    this.onAddressChange = this.onAddressChange.bind(this);
  }

  componentDidMount() {
    loadGoogleMapsPlaces()
      .then(() => this.setState({ mapsReady: true }))
      .catch(() => this.setState({ mapsLoadFailed: true }));
  }

  onAddressChange(address) {
    const { input } = this.props;
    const { onChange } = input;
    this.setState({ address });
    onChange(address);
  }

  renderFallbackInput() {
    const {
      input,
      controlId,
      label,
      placeholder,
      className,
      touched,
      error,
      helpText,
      helpTextId,
      addressErrorDetail,
    } = this.props;

    return (
      <div className={classNames('form-group', className)}>
        {label && <label htmlFor={controlId}>{label}</label>}
        <div className={classNames('input', { error: touched && error !== null }, 'input-group')}>
          <input
            className="form-control"
            {...input}
            placeholder={placeholder}
            autoComplete="none"
            id={controlId}
          />
        </div>
        {helpText && <small id={helpTextId} className="form-text text-muted">{helpText}</small>}
        {addressErrorDetail && <div className="is-error invalid-feedback">{addressErrorDetail}</div>}
      </div>
    );
  }

  render() {
    const {
      controlId,
      label,
      placeholder,
      className,
      onSelect,
      type,
      touched,
      error,
      helpText,
      helpTextId,
      addressErrorDetail,
    } = this.props;
    const {
      address, mapsReady, mapsLoadFailed,
    } = this.state;

    if (mapsLoadFailed) {
      return this.renderFallbackInput();
    }

    if (!mapsReady) {
      return (
        <div className={classNames('form-group', className)}>
          {label && <label htmlFor={controlId}>{label}</label>}
          <div className="autocomplete-results center">
            <Spinner className="spinner" name="ball-spin-fade-loader" />
          </div>
        </div>
      );
    }

    return (
      <PlacesAutocomplete
        value={address}
        onChange={this.onAddressChange}
        placeholder={placeholder}
        onSelect={onSelect}
        type={type}
        searchOptions={{ types: ['address'] }}
      >
        {({
          getInputProps, suggestions, getSuggestionItemProps, loading,
        }) => (
          <div className={classNames('form-group', className)}>
            {label && <label htmlFor={controlId}>{label}</label>}
            <div className={classNames('input', { error: touched && error !== null }, 'input-group')}>
              <input
                aria-describedby="addressAutocomplete"
                autoComplete="none"
                {...getInputProps({
                  placeholder,
                  className: 'form-control',
                  id: controlId,
                })}
              />
            </div>
            <div className="autocomplete-results center">
              {loading && <Spinner className="spinner" name="ball-spin-fade-loader" />}
              {suggestions.map((suggestion) => {
                const suggestionClassName = suggestion.active ? 'active' : '';
                const style = {
                  backgroundColor: suggestion.active ? '#fafafa' : '#ffffff',
                  cursor: 'pointer',
                };
                return (
                  <div
                    key={suggestion.placeId}
                    {...getSuggestionItemProps(suggestion, {
                      className: suggestionClassName,
                      style,
                    })}
                  >
                    <a href="#" className="list-group-item list-group-item-action">{suggestion.description}</a>
                  </div>
                );
              })}
            </div>
            {helpText && <small id={helpTextId} className="form-text text-muted">{helpText}</small>}
            {addressErrorDetail && <div className="is-error invalid-feedback">{addressErrorDetail}</div>}
          </div>
        )}
      </PlacesAutocomplete>
    );
  }
}
